import {
    EmptyFormatter,
    ArrayFormatter,
    BooleanFormatter,
    DurationFormatter,
    DefaultFormatter,
} from '../components/Formatters';

interface FormatterRule {
    match: (key: string, value: unknown) => boolean;
    component: React.ElementType;
}

const rules: FormatterRule[] = [
    {
        match: (_, value) =>
            value === null || value === undefined || value === '',
        component: EmptyFormatter,
    },
    {
        match: (_, value) => Array.isArray(value),
        component: ArrayFormatter,
    },
    {
        match: (_, value) => typeof value === 'boolean',
        component: BooleanFormatter,
    },
    {
        match: (key) => key === 'duration',
        component: DurationFormatter,
    },
];

export const resolveFormatter = (
    key: string,
    value: unknown,
): React.ElementType => {
    const rule = rules.find((r) => r.match(key, value));
    return rule ? rule.component : DefaultFormatter;
};
